import { render, staticRenderFns } from "./UserService.vue?vue&type=template&id=59f99fb8&"
import script from "./UserService.vue?vue&type=script&lang=js&"
export * from "./UserService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports